import React from "react";
import { useTranslation } from 'react-i18next';
import { Button, Dialog } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import LockIcon from "@mui/icons-material/Lock";
//--
import "./UnAuthroizedRoute.scss";

interface IProps {
  location: {
    pathname: string;
  };
}

export const UnAuthorizedRoute = (props: IProps) => {
  const { t } = useTranslation();
  const { location } = props;
  const [open, setOpen] = React.useState(true);

  const handleClose = () => {
    setOpen(false);
  };

  const getClaimName = () => {
    const pathname: string = location?.pathname;
    return pathname;
  };

  return (
    <Dialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      className="sc-unauthorized-route"
      open={open}
    >
      <div className="modal">
        <div className="head">
          <Button className="btn-close trigger" onClick={handleClose}>
            <CloseIcon />
          </Button>
        </div>
        <div className="content">
          <div className="auth-error">
            <LockIcon />
            <h3> 
              {t('authorization.notAuthorized')}
            </h3>
            <h5>
              {t('authorization.contactSystemAdmin')}
            </h5>
            <h6>
              {t('authorization.requiredAuthority')} <u>{getClaimName()}</u>
            </h6>
          </div>
        </div>
      </div>
    </Dialog>
  );
};
